import React from 'react';

import { getSubdomain, isSaaSSubdomain } from 'utils/getSubdomain';
import SaaSVSidebarContent from './SaaSVSidebarContent';
import SidebarContent from './SidebarContent';

const HorizontalSidebarContent = () => {
  const isSaaS = isSaaSSubdomain();

  return isSaaS ? <SaaSVSidebarContent /> : <SidebarContent />;
};

export default HorizontalSidebarContent;
